import { useMemo } from "react";
import ReactECharts from "echarts-for-react";

import { processDetailInstrumentChartData } from "../utils/utils";

export function ComparatorChart({ firstOptionData, secondOptionData, thirdOptionData }) {
    // const isLoading = firstOptionIsLoading || secondOptionIsLoading || thirdOptionIsLoading;
    // const isError = firstOptionIsError || secondOptionIsError || thirdOptionIsError;

    const firstOptionDataObj = firstOptionData ? firstOptionData[0] : [];
    const secondOptionDataObj = secondOptionData ? secondOptionData[0] : [];
    const thirdOptionDataObj = thirdOptionData ? thirdOptionData[0] : [];

    const firstOptionValuaciones = firstOptionDataObj?.valuaciones;
    const secondOptionValuaciones = secondOptionDataObj?.valuaciones;
    const thirdOptionValuaciones = thirdOptionDataObj?.valuaciones;

    // Utilizamos useMemo para procesar datos y evitar recálculos innecesarios
    const { xAxisData, series } = useMemo(() => {
        // Procesamos los datos de cada opción
        const processedOptions = [
            firstOptionData ? processDetailInstrumentChartData(firstOptionValuaciones, "variacion") : null,
            secondOptionData ? processDetailInstrumentChartData(secondOptionValuaciones, "variacion") : null,
            thirdOptionData ? processDetailInstrumentChartData(thirdOptionValuaciones, "variacion") : null,
        ].filter((option) => option !== null); // Filtramos las opciones no procesadas

        // Asumimos que el eje X es común para todas las series, por lo tanto, tomamos el del primer conjunto de datos
        const xAxisData = processedOptions.length > 0 ? processedOptions[0].xAxisData : [];

        // Construimos las series para ECharts
        const series = processedOptions.map((option) => ({
            data: option.seriesData,
            type: "line",
        }));

        return { xAxisData, series };
    }, [firstOptionData, secondOptionData, thirdOptionData]);

    const options = {
        grid: { top: 24, right: 40, bottom: 80, left: 80 },
        xAxis: {
            type: "category",
            data: xAxisData,
        },
        yAxis: {
            type: "value",
        },
        series: series,
        tooltip: {
            trigger: "axis",
        },
        dataZoom: [
            { type: "inside", xAxisIndex: [0], start: 0, end: 100 },
            { type: "slider", xAxisIndex: [0], start: 0, end: 100 },
            { type: "inside", yAxisIndex: [0], start: 0, end: 100 },
            { type: "slider", yAxisIndex: [0], start: 80, end: 100, right: 0 },
        ],
        toolbox: {
            feature: {
                dataZoom: { yAxisIndex: "none" },
                restore: {},
                saveAsImage: {},
            },
        },
    };

    return <div className="cot-lines-chart">{<ReactECharts option={options} />}</div>;
}
